module.exports = __webpack_public_path__ + "static/media/success.285ef997.gif";